/** Assets de banner home — mismos del landing PN/PJ. */
export const HOME_BANNER_IMAGE_NATURAL =
  'assets/img/landing/landing-bienvenida-natural.png';
export const HOME_BANNER_IMAGE_NATURAL_MOBILE =
  'assets/img/landing/landing-bienvenida-natural-mobile.png';
export const HOME_BANNER_IMAGE_JURIDICA =
  'assets/img/landing/landing-bienvenida-juridica.png';
export const HOME_BANNER_IMAGE_JURIDICA_MOBILE =
  'assets/img/landing/landing-bienvenida-juridica-mobile.png';
